export const CSS = {
  active: "is-active",
  open: "is-open",
  overflowHidden: "overflow--hidden",
  ready: "is-ready",
  removing: "removing",
  visible: "is-visible",
};
